import { Fragment, memo } from 'react';
import Accountholder from '../shared/accountholder';
import Applicant from '../shared/applicant';
import Payment from '../shared/fragment-payment';

interface CertificateFormProps {
  disabled?: boolean;
}

const CertificateFormComponent = ({ disabled }: CertificateFormProps): React.ReactElement => {
  return (
    <Fragment>
      <Payment />
      <Applicant disabled={disabled} />
      <Accountholder disabled={disabled} />
    </Fragment>
  );
};

CertificateFormComponent.displayName = 'Certificate Form component';

const CertificateForm = memo(CertificateFormComponent);

export default CertificateForm;
